import { useId } from "react";

import { copy, type DirectionCard } from "@core/index.js";

export const EvidenceDrawer = ({ direction }: { direction: DirectionCard }) => {
  const id = useId();
  const palette = direction.colour?.systems.find((system) => system.id === direction.selected.paletteSystemId) ?? null;
  if (!palette) return null;
  return (
    <details className="drawer" aria-describedby={`${id}-hint`}>
      <summary id={`${id}-hint`}>{copy.result.evidenceLabel}</summary>
      <div className="drawer-body">
        <h3>How this color result can be repeated</h3>
        <p>The engine uses the same normalized pixels, declared answers, and version every time. This is the receipt—not homework for using the palette.</p>
        <table className="trace-table">
          <tbody>
            <tr><th scope="row">Engine</th><td>{palette.determinism.engineVersion}</td></tr>
            <tr><th scope="row">Working-pixel fingerprint</th><td><code>{palette.determinism.workingPixelHash}</code></td></tr>
            <tr><th scope="row">Image area</th><td>x {palette.determinism.crop.x.toFixed(3)}, y {palette.determinism.crop.y.toFixed(3)}, w {palette.determinism.crop.width.toFixed(3)}, h {palette.determinism.crop.height.toFixed(3)}</td></tr>
            <tr><th scope="row">What ran</th><td>{palette.determinism.capabilities.join(", ")}</td></tr>
          </tbody>
        </table>
        <h3>Truth and limits</h3>
        <ul>
          <li>The palette is deterministic from the working pixels, your choices, and the engine version above.</li>
          <li>Contrast checks are pair-specific. They do not certify every future slide, chart, projector, or print process.</li>
          <li>Chart color still needs labels, shape, ordering, and testing with real values.</li>
          <li>A palette can make hierarchy visible. It cannot make a weak argument persuasive. Annoying, but true.</li>
        </ul>
      </div>
    </details>
  );
};
